import { createBrowserRouter, Navigate } from "react-router-dom";
import type { Store } from "@reduxjs/toolkit";
import AppProviders from "../providers/AppProviders";
import NotFound from "../../components/errors/NotFound";
import PrivacyPolicyPage from "../../features/privacyPolicy/component/PrivacyPolicyPage";
import TermsAndConditions from "../../features/TermsAndConditin/components/TermsAndConditionPage";
import AuthProtected from "./AuthProtected";
import GuestRoute from "./GuestRoute";
import Login from "../../features/auth/Login";
import Survey from "../../features/survey";
import BeginSurvey from "../../features/survey/BeginSurvey";
import CreateAccount from "../../features/auth/CreateAccount";
import SignupComplete from "../../features/auth/SignupComplete";
import LockerRoom from "../../features/locker-room";
import IndividualResults from "../../features/individual-results";
import AccountSettings from "../../features/auth/AccountSettings";
import NotificationInboxPage from "../../features/notification/components/NotificationInboxPage";
import FaqHelpPage from "../../features/faq/pages/FaqHelpPage";
import UserManagementPage from "../../features/TeamcompositeResults/components/UserManagementPage";
import MainAppLayout from "../layouts/MainAppLayout";
import ForgotPassword from "../../features/auth/ForgotPassword";
import ResetPassword from "../../features/auth/ResetPassword";

export function createAppRouter(store: Store) {
  return createBrowserRouter([
    {
      element: <AppProviders store={store} />,
      children: [
        // Guest
        {
          element: <GuestRoute />,
          children: [
            { path: "/login", element: <Login /> },
            { path: "/forgot-password", element: <ForgotPassword /> },
            { path: "/reset-password/:token", element: <ResetPassword /> }

          ],
        },

        // Protected
        {
          element: <AuthProtected />,
          children: [
            { path: "/", element: <Navigate to="/locker-room" replace /> },
            { path: "/survey", element: <Survey /> },
            { path: "/begin-survey", element: <BeginSurvey /> },
            { path: "/create-account", element: <CreateAccount /> },
            { path: "/signup-complete", element: <SignupComplete /> },

            {
              element: <MainAppLayout />,
              children: [
                { path: "/locker-room", element: <LockerRoom /> },
                { path: "/individual-results", element: <IndividualResults /> },
                { path: "/account-settings", element: <AccountSettings /> },
                { path: "/notifications", element: <NotificationInboxPage /> },
                { path: "/help", element: <FaqHelpPage /> },
                { path: "/user-management", element: <UserManagementPage /> },
              ],
            },
          ],
        },

        // Static
        { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
        { path: "/communication-usage-terms", element: <TermsAndConditions /> },
        { path: "/not-found", element: <NotFound /> },

        // Fallback
        { path: "*", element: <NotFound /> },
      ],
    },
  ]);
}
